import React, { Component } from 'react'
import { Spin } from 'antd'
import numeral from 'numeral'
import _ from 'lodash'

import './ItemSmartSuggestionTable.scss'

export default class ItemSmartSuggestionTable extends Component {
    getItemTotal(item) {
        const { quantity, basic_charge, basic_charge_quantity, unit_rate } = item
        const basic_charge_per_unit = Math.round(basic_charge / basic_charge_quantity)
        if (quantity >= 0 && basic_charge && basic_charge_quantity) {
            if (basic_charge_quantity >= quantity)
                return basic_charge_per_unit * quantity
            else
                return basic_charge + (quantity - basic_charge_quantity) * unit_rate
        } else {
            return quantity * unit_rate
        }
    }

    render() {
        const { visible, dataSource, onMouseDown, onRowClick } = this.props
        if (!visible)
            return null
        else if (dataSource.loading)
            return (
                <div className="ItemSmartSuggestionTable" onMouseDown={onMouseDown}>
                    <div className="smart-suggestion-loading">
                        <Spin />
                    </div>
                </div>
            )
        else
            return (
                <div className="ItemSmartSuggestionTable" onMouseDown={onMouseDown}>
                    <p>Related Record for Item "{dataSource.keyword}":</p>
                    <table>
                        <thead>
                            <tr>
                                <th>Project Name</th>
                                <th width={80}>Qty</th>
                                <th width={80} colSpan={2}>Basic Charge</th>
                                <th width={80} colSpan={2}>Unit Rate</th>
                                <th width={120}>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                dataSource.suggestionList.length !== 0 ? _.map(dataSource.suggestionList, (record, idx) => {
                                    const { quantity, basic_charge, basic_charge_quantity, unit_rate, unit } = record.item
                                    return (
                                        <tr key={idx} onClick={onRowClick.bind(this, record.item)}>
                                            <td>{record.project_name}</td>
                                            <td>{quantity}</td>
                                            <td>{basic_charge && `$ ${numeral(basic_charge).format('0,0')}`}</td>
                                            <td>{basic_charge_quantity && `First ${basic_charge_quantity}`}</td>
                                            <td>{unit_rate && `$ ${numeral(unit_rate).format('0,0')}`}</td>
                                            <td>{unit}</td>
                                            <td>{numeral(this.getItemTotal(record.item)).format('$ 0,0')}</td>
                                        </tr>
                                    )}
                                ) : (
                                    <tr>
                                        <td colSpan={7}>No Result</td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                </div>
            )
    }
}



// WEBPACK FOOTER //
// ./src/Commons/ItemSmartSuggestionTable/ItemSmartSuggestionTable.js